<template>
    <section class="panel">
        <header class="panel-heading bg-primary">
            <div class="panel-heading-icon">
                <i class="fa fa-user-circle"></i>
            </div>
        </header>
        <div class="panel-body text-left">
            <h3 class="text-weight-semibold mt-sm text-center">Bienvenido al Portal de Clientes</h3>

            <div class="alert alert-warning" v-if="typeof(accountIsEnabled) !== 'undefined' && !accountIsEnabled">
                Su correo está pendiente de ser asociado a una cuenta de Cuatro Torres, este paso estará listo en aproximadamente
                de 24 a 48 horas; si ya pasaron 48h y no ha sido activada favor de ponerse en
                contacto con el administrador llamando al 614-423-1798.
            </div>

            <p><b>¿Que puedes hacer en este portal?</b></p>
            <p>Ver el estado de tú última factura</p>
            <p>Ver y descargar tus facturas desde Enero 2017</p>
            <p>Contactarnos para diferentes asuntos</p>
            <p>Ver los documentos de tu contratación</p>
            <p>Próximamente: Reservar la sala de juntas</p>
            
            <div class="alert alert-info fade in" v-if="lastAnnouncement">
                <h4>Anuncio: <b>{{ lastAnnouncement.title }}</b></h4>
                <p v-html="lastAnnouncement.content"></p>
            </div>
        </div>
    </section>
</template>

<script>
    module.exports = {
        name: 'Announcements',
        data: function () {
            return {
                isLoading: true,
                accountIsEnabled: null,
                lastAnnouncement : null
            }
        },
        mounted: function(){
            this.$nextTick(function () {
                this.refresh();
            });
        },
        methods: {
             async refresh() {
                var self = this;
                this.isLoading = true;

                const jwtAccessToken = await this.$auth.getTokenSilently();
                const jwtIdToken = (await this.$auth.getIdTokenClaims()).__raw;

                this.axios.get(process.env.VUE_APP_API_PATH + "setup/is-account-linked",
                        {
                            headers: {
                                Authorization: `Bearer ${jwtAccessToken}`,  // send the access token through the 'Authorization' header,
                                IdToken: `${jwtIdToken}`
                            }
                        }
                    ).
                    then(function (response) {
                        self.accountIsEnabled = response.data;
                        self.isLoading = false;
                    }, function (error) {
                        self.isLoading = false;
                    });

                this.axios.get(process.env.VUE_APP_API_PATH + "announcements/last",
                        {
                            headers: {
                                Authorization: `Bearer ${jwtAccessToken}`,  // send the access token through the 'Authorization' header,
                                IdToken: `${jwtIdToken}`
                            }
                        }
                    ).
                    then(function (response) {
                        self.lastAnnouncement = response.data;
                        self.isLoading = false;
                    }, function (error) {
                        self.isLoading = false;
                    });
            }
        }
    }
</script>